import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import { withStyles } from '@material-ui/core/styles';
import Model from '../../api/Model';
import FormStep from '../../components/form/FormStep';
import FormField from '../../components/form/FormField';
import Form from '../../components/form/Form';
import currentUser from '../../store/currentUser';
import PermissionChecker from '../../components/permissions/PermissionChecker';
import Version from '../../api/Version';
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import Switch from "@material-ui/core/Switch";
import {observable} from "mobx";

const styles = theme => ({
  paper: {
    padding: theme.spacing(2),
  },
});


@withStyles(styles)
@observer
class VersionForm extends React.Component {
  static propTypes = {
    instance: PropTypes.instanceOf(Model).isRequired,
  };

  @observable isEUFormat = false;

  get typeChoices() {
    if (Version.fieldsData === null) {
      return {};
    }
    const options = {};
    for (const { value, display_name } of Version.fieldsData.type.choices) {
      if (currentUser.can(`athena.create_${value}`)) {
        options[value] = display_name;
      }
    }
    return options;
  }

  onTypeChange = (event, instance) => {
    if (!instance.canBeCertified) {
      instance.certified = false;
    }
  };

  onFormatChange = (instance, newValue) => {
    this.isEUFormat = newValue;
    instance['format'] = newValue
  }

  render() {
    const { instance, classes } = this.props;
    return (
      <Form instance={instance} redirectPath={instance => '/input-files/'}>
        <FormStep>
          <Paper className={classes.paper}>
            <Grid container spacing={2} direction="column" wrap="nowrap">
              <Grid item container spacing={2}>
                <Grid item xs={6}>
                  <FormField name="cycle_year" fullWidth />
                </Grid>
                <Grid item xs={6}>
                  <FormField name="cycle_month" fullWidth />
                </Grid>
              </Grid>
              <Grid item>
                <FormField name="technology_family" fullWidth />
              </Grid>
              <Grid item>
                <FormField
                  name="type"
                  fullWidth
                  options={this.typeChoices}
                  onChange={this.onTypeChange}
                />
              </Grid>
              <Grid item>
                <FormField name="name" fullWidth />
              </Grid>
              <Grid item>
                <FormField name="file" fullWidth />
              </Grid>
              <Grid item container spacing={2}>
                <Grid item xs={6}>
                  <PermissionChecker permission={instance.canBeCertified}>
                    {
                      hasPermission =>
                        <FormField
                          name="certified"
                          disabled={!hasPermission}
                        />
                    }
                  </PermissionChecker>
                </Grid>
                {instance.type === 'production_plan' | instance.type === 'standard_cost_prices' ? (
                  <Grid item xs={6}>
                    <Box display="flex" justifyContent="flex-end">
                      <Typography noWrap>
                        EU Format
                        <Switch
                            name="format"
                            checked={this.isEUFormat}
                            onChange={(e, v) => this.onFormatChange(instance, v)}
                        />
                      </Typography>
                    </Box>
                  </Grid>
                ) : null}
              </Grid>
            </Grid>
          </Paper>
        </FormStep>
      </Form>
    );
  }
}


export default VersionForm;
